module.exports = __webpack_public_path__ + "gn.svg?e2dcda47e6c4a060104aaa7be670bf86";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/gn.svg
// module id = 1380
// module chunks = 0